module.exports = __webpack_public_path__ + "static/LaptopDashboard-d84c12fc7737b72e6b5d411614b0e65d.png";